@if ((breadcrumbs$ | async)?.length!==0) {
<p-breadcrumb
  [model]="(breadcrumbs$ | async) || []"
  [home]="{ icon: 'pi pi-home  text-2xl', routerLink: '/' }"
>
  <ng-template #item let-item>
    <a
      class="text-[#94A3B8] font-medium"
      [routerLink]="item.routerLink"
      [queryParams]="item.queryParams"
    >
      {{ item.label | transloco }}
    </a>
  </ng-template>
</p-breadcrumb>
}
